<div class="dialog-container">
    <h1 class="dialog-title" mat-dialog-title>Confirmer la suppression</h1>
    <div class="dialog-content" mat-dialog-content>
        <p>Êtes-vous sûr de vouloir procéder à la suppression ??</p>
    </div>
    <div class="dialog-actions" mat-dialog-actions>
        <button mat-button class="dialog-button" class="btn btn-warning" (click)="onCancel()">Annuler</button>
        <button mat-button class="dialog-button" class="btn btn-primary" (click)="onConfirm()">Confirmer</button>
    </div>
</div>